// @ts-nocheck
import { createFromProduct, ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import {
    GetProductCollectionApiV2Parameter,
    getProductCollectionV2,
} from "@insite/client-framework/Services/ProductServiceV2";
import loadRealTimeInventory from "@insite/client-framework/Store/CommonHandlers/LoadRealTimeInventory";
import loadRealTimePricing from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";
import { ProductCollectionModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import { getProductBySndSku } from "@store/Framework/Services/ScratchAndDentService";
import {
    createHandlerChainRunner,
    Handler,
    HasOnError,
    HasOnSuccess,
} from "@toolkit/Modules/client-framework/HandlerCreator";

type Parameter = GetProductCollectionApiV2Parameter &
    HasOnSuccess<ProductCollectionModel> &
    HasOnError<string> & { widgetId: string };
type Props = {
    apiParameter: GetProductCollectionApiV2Parameter & { apiType?: string; widgetId?: string };
    apiResult: ProductCollectionModel | undefined | null;
    productInfos?: ProductInfo[];
};

type HandlerType = Handler<Parameter, Props>;

export const StartProductInfoLists: HandlerType = props => {
    props.dispatch({
        type: "Components/ProductInfoLists/SetWaitingForData",
        id: props.parameter.widgetId,
        parameter: {
            productId: props.parameter.widgetId,
        } as GetProductCollectionApiV2Parameter,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    const { onSuccess, onError, ...parameter } = props.parameter;
    props.apiParameter = { ...parameter };
};

export const DispatchBeginLoadProducts: HandlerType = props => {
    props.dispatch({
        type: "Data/Products/BeginLoadProducts",
        parameter: props.parameter,
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getProductCollectionV2(props.apiParameter);
    } catch (error) {
        props.parameter.onError?.(error);
    }
};

export const DispatchCompleteLoadProducts: HandlerType = props => {
    props.dispatch({
        type: "Data/Products/CompleteLoadProducts",
        collection: props.apiResult!,
        parameter: props.parameter,
    });
};

export const SetUpProductInfos: HandlerType = props => {
    if (!props.apiResult) {
        return;
    }

    props.productInfos = [];
    if (!props.apiResult || !props.apiResult.products) {
        return;
    }
    props.apiResult.products.forEach(productModel => {
        props.productInfos!.push(createFromProduct(productModel));
    });

    props.dispatch({
        type: "Components/ProductInfoLists/CompleteLoadProductInfoList",
        id: props.parameter.widgetId!,
        parameter: {
            productId: props.parameter.widgetId,
        } as GetProductCollectionApiV2Parameter,
        productInfos: props.productInfos ?? [],
    });

    props.dispatch(
        loadRealTimePricing({
            productPriceParameters: props.productInfos,
            onSuccess: realTimePricing => {
                props.dispatch({
                    type: "Components/ProductInfoLists/CompleteLoadRealTimePricing",
                    id: props.parameter.widgetId!,
                    realTimePricing,
                });
            },
            onError: () => {
                props.dispatch({
                    type: "Components/ProductInfoLists/FailedLoadRealTimePricing",
                    id: props.parameter.widgetId!,
                });
            },
            onComplete(realTimePricingProps) {
                if (realTimePricingProps.apiResult) {
                    this.onSuccess?.(realTimePricingProps.apiResult);
                } else if (realTimePricingProps.error) {
                    this.onError?.(realTimePricingProps.error);
                }
            },
        }),
    );

    props.dispatch(
        loadRealTimeInventory({
            productIds: props.productInfos.map(o => o.productId),
            onSuccess: realTimeInventory => {
                props.dispatch({
                    type: "Components/ProductInfoLists/CompleteLoadRealTimeInventory",
                    id: props.parameter.widgetId!,
                    realTimeInventory,
                });
            },
            onError: () => {
                props.dispatch({
                    type: "Components/ProductInfoLists/FailedLoadRealTimeInventory",
                    id: props.parameter.widgetId!,
                });
            },
            onComplete(realTimeInventoryProps) {
                if (realTimeInventoryProps.apiResult) {
                    this.onSuccess?.(realTimeInventoryProps.apiResult);
                } else if (realTimeInventoryProps.error) {
                    this.onError?.(realTimeInventoryProps.error);
                }
            },
        }),
    );
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult!);
};

export const chain = [
    StartProductInfoLists,
    PopulateApiParameter,
    DispatchBeginLoadProducts,
    RequestDataFromApi,
    DispatchCompleteLoadProducts,
    SetUpProductInfos,
    ExecuteOnSuccessCallback,
];

const displayProductList = createHandlerChainRunner(chain, "displayProductList");
export default displayProductList;
